import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      WELL_DONE: "Bra jobba!",
      DELICIOUS_MEALKIT: "Din personlige matkasse, designet av deg",
      CHOOSE_BETWEEN: "Velg mellom ",
      DISHES_PER_WEEK: "retter hver uke",
      SHOW_PERSONALIZED_MENU: "Vis min skreddersydde meny",
      CONTINUE: "Opprett konto",
      YOU_CAN_CHANGE_ANYTIME:
        "Du kan når som helst endre preferanser, hoppe over, pause eller si opp abonnementet ditt.",
      READ_MORE: "Les mer.",
    },
    se: {
      WELL_DONE: "Bra jobbat!",
      DELICIOUS_MEALKIT: "Din personliga matkasse, skapad av dig",
      CHOOSE_BETWEEN: "Välj mellan ",
      DISHES_PER_WEEK: "rätter varje vecka",
      SHOW_PERSONALIZED_MENU: "Visa min personliga meny",
      CONTINUE: "Fortsätt för att skapa konto",
      YOU_CAN_CHANGE_ANYTIME:
        "Du kan när som helst ändra dina preferenser, hoppa över veckor, pausa eller avbryta din prenumeration.",
      READ_MORE: "Läs mer.",
    },
    dk: {
      WELL_DONE: "Godt gået!",
      DELICIOUS_MEALKIT: "Din personlige måltidskasse, designet af dig.",
      CHOOSE_BETWEEN: "Vælg mellem",
      DISHES_PER_WEEK: "retter hver uge",
      SHOW_PERSONALIZED_MENU: "Vis min skræddersyede menu",
      CONTINUE: "Fortsæt med at oprette konto",
      YOU_CAN_CHANGE_ANYTIME:
        "Du kan til enhver tid ændre dine præferencer, springe leveringsuger over, opsige eller sætte dit abonnement på pause.",
      READ_MORE: "Læs mere.",
    },
  } as const
)[language];
